import { Box } from "@chakra-ui/react";
import { VStack } from "goi_common";
import ParlorOnlyQuotationRequest from "./ParlorQuotationRequest/ParlorOnlyQuotationRequest";

export default function ParlorMatchRequestSection() {
  return (
    <VStack>
      <VStack gap="10px" padding="18px 24px 0">
        <Box className="head2_b black">장례식장 추천받기</Box>
      </VStack>
      <VStack>
        <ParlorOnlyQuotationRequest />
      </VStack>
    </VStack>
  );
}
